import React from "react";
import ImageGallery from "react-image-gallery";

export default class ProductGallery extends React.Component {
  constructor(props) {
    super(props);
    //should be options to options that are passed in as props
    //state only is necessary if there is something
    //that will change dynamically during the lifecycle of the
    //component
    let photo_navigation  =  this.props.product_photo_navigation || 'thumbnails'

    this.state = {
      showIndex: false,
      showBullets: false,
      infinite: true,
      showThumbnails:  (photo_navigation === 'thumbnails' || photo_navigation === 'both' ), 
      showFullscreenButton: true,
      showGalleryFullscreenButton: true,
      showPlayButton: false,
      showGalleryPlayButton: true,
      showNav: (photo_navigation === 'arrows' || photo_navigation === 'both') ,
      isRTL: false,
      slideDuration: 450,
      slideInterval: 2000,
      slideOnThumbnailOver: false,
      thumbnailPosition: this.props.product_photo_placement,
      showVideo: {},
      useWindowKeyDown: true,
    };
    this.images = this.fetchImages(this.props.product);
  }

  fetchImages(product) {
    let t = this;
    let images = [];
    if (product) {
      images.push({
        thumbnail: product.image,
        original: product.image,
        description: product.name,
        originalAlt: product.name, 
        thumbnailAlt: product.name,
      });
      if (product.additional_images && product.additional_images.length > 0) {
        product.additional_images.map((img, i) => {
          if (img.type === "video_embed") {
            images.push({
              embedUrl: img.url,
              description: img.name,
              thumbnail: img.thumbnail,
              original: img.original,
              originalAlt: img.name, 
              thumbnailAlt: img.name,
              renderItem: t._renderVideo.bind(t),
            });
          } else {
            images.push({
              thumbnail: img.url,
              original: img.url,
              originalAlt: img.name, 
              thumbnailAlt: img.name,
              description: img.name,
            });
          }
        });
      }
    }
    return images;
  }

  _onImageClick(event) {
    console.debug(
      "clicked on image",
      event.target,
      "at index",
      this._imageGallery.getCurrentIndex()
    );
  }

  _onImageLoad(event) {}

  _onSlide(index) {
    this._resetVideo();
  }

  _onPause(index) {}

  _onScreenChange(fullScreenElement) {}

  _onPlay(index) {}

  _handleInputChange(state, event) {
    if (event.target.value > 0) {
      this.setState({ [state]: event.target.value });
    }
  }

  _handleCheckboxChange(state, event) {
    this.setState({ [state]: event.target.checked });
  }

  _handleThumbnailPositionChange(event) {
    this.setState({ thumbnailPosition: event.target.value });
  }

  _resetVideo() {
    this.setState({ showVideo: {} });

    if (this.state.showPlayButton) {
      this.setState({ showGalleryPlayButton: true });
    }

    if (this.state.showFullscreenButton) {
      this.setState({ showGalleryFullscreenButton: true });
    }
  }

  _toggleShowVideo(url) {
    this.state.showVideo[url] = !Boolean(this.state.showVideo[url]);
    this.setState({
      showVideo: this.state.showVideo,
    });

    if (this.state.showVideo[url]) {
      if (this.state.showPlayButton) {
        this.setState({ showGalleryPlayButton: false });
      }

      if (this.state.showFullscreenButton) {
        this.setState({ showGalleryFullscreenButton: false });
      }
    }
  }

  _renderVideo(item) {
    return (
      <div className="video-wrapper">
        <a
          className="close-video"
          onClick={this._toggleShowVideo.bind(this, item.embedUrl)}
        ></a>
        <iframe
          width="560"
          height="315"
          src={item.embedUrl}
          frameBorder="0"
          allowFullScreen
        ></iframe>
      </div>
    );
  }

  render() {
    return (
      <section className="app">
        <ImageGallery
          ref={(i) => (this._imageGallery = i)}
          items={this.images}
          onClick={this._onImageClick.bind(this)}
          onImageLoad={this._onImageLoad}
          onSlide={this._onSlide.bind(this)}
          onPause={this._onPause.bind(this)}
          onScreenChange={this._onScreenChange.bind(this)}
          onPlay={this._onPlay.bind(this)}
          infinite={this.state.infinite}
          showBullets={this.state.showBullets}
          showFullscreenButton={
            this.state.showFullscreenButton &&
            this.state.showGalleryFullscreenButton
          }
          showPlayButton={
            this.state.showPlayButton && this.state.showGalleryPlayButton
          }
          showThumbnails={this.state.showThumbnails}
          showIndex={this.state.showIndex}
          showNav={this.state.showNav}
          isRTL={this.state.isRTL}
          thumbnailPosition={this.state.thumbnailPosition}
          slideDuration={parseInt(this.state.slideDuration)}
          slideInterval={parseInt(this.state.slideInterval)}
          slideOnThumbnailOver={this.state.slideOnThumbnailOver}
          additionalClass="app-image-gallery"
          useWindowKeyDown={this.state.useWindowKeyDown}
        />
      </section>
    );
  }
}
